// import { Dispatch, Action } from 'redux'
// import { createSubmitAction } from 'actionCreators/submit/Submit/createSubmitAction'
// import { SUBMIT_DELETE_TASK_TAG } from 'actions'

import {
  // TitleWatcherConnectedProps,
  TitleWatcherMapDispatchReturnType,
} from './types'

export const TitleWatcherMapDispatch = (
  // dispatch: Dispatch<Action>,
  // props: TitleWatcherConnectedProps,
): TitleWatcherMapDispatchReturnType => {
  return {
  }
}
